import { WarningCircle } from 'phosphor-react'

import { DialogModal } from '../../../../../components/DialogModal'
import { Button } from '../../../../../components/Button'

type DeleteTaskModalProps = {
  isRemoving: boolean
  isOpen: boolean
  onClose: () => void
  onDelete: () => void
}

export const DeleteTaskModal = ({
  isRemoving,
  isOpen,
  onClose,
  onDelete,
}: DeleteTaskModalProps) => {
  return (
    <DialogModal isOpen={isOpen} onClose={onClose}>
      <div className="px-8 py-6">
        <WarningCircle size={72} className="mx-auto mb-10 text-primary-light" />

        <p className="mb-6 text-center">
          Atenção! Você está prestes a excluir uma task. Deseja continuar?
        </p>

        <div className="flex gap-2 mt-14">
          <Button
            size="large"
            variant="outline"
            className="flex-1"
            onClick={onClose}
          >
            Cancelar
          </Button>
          <Button
            onClick={onDelete}
            isLoading={isRemoving}
            size="large"
            className="flex-1"
          >
            Excluir
          </Button>
        </div>
      </div>
    </DialogModal>
  )
}
